export class ProductDisplayMode {
	static ROW = "row";
	static LIST = "list";
	static CARD = "card";
	static CARD_COMPACT = "card-compact";

	static getTranslationKeyForMode(mode: Readonly<ProductDisplayMode>) {
		return `view.` + mode;
	}

	static isValidDisplayMode(mode: string): boolean {
		return Object.values(ProductDisplayMode).includes(mode);
	}
}